import React from 'react';

const LOCALE_FALLBACK = 'fr-FR';

const useBrowserLocale = () => {
  const [browserLocale, setBrowserLocale] = React.useState('');

  React.useEffect(() => {
    const syncWithNavigatorLanguage = () => {
      if (navigator.language) {
        setBrowserLocale(navigator.language);
      } else {
        setBrowserLocale(LOCALE_FALLBACK);
      }
    };

    syncWithNavigatorLanguage();
    window.addEventListener('languagechange', syncWithNavigatorLanguage);
    return window.removeEventListener('languagechange', syncWithNavigatorLanguage);
  }, []);

  return browserLocale;
};

// [TODO Update version] When current React version will be ≥18.0.0, opt for this approach instead
// const subscribe = (callback) => {
//   window.addEventListener('languagechange', callback);
//   return window.removeEventListener('languagechange', callback);
// };

// const getSnapshot = () => navigator.language ?? 'fr-FR';

// const useBrowserLocale = () => {
//   const language = React.useSyncExternalStore(subscribe, getSnapshot);
//   return language;
// };

export default useBrowserLocale;



// WEBPACK FOOTER //
// ./hooks/useBrowserLocale.js